import { strCode } from "../../../../../consts";
import { t } from "../../../../../services";

import { IconButton, SVG } from "../../../../../components";
import { FileUploadErrorWrapper } from "../styled";

export const FileUploadError = () => {
  return (
    <FileUploadErrorWrapper>
      <IconButton tooltipLabel={t(strCode.NO_FILE_UPLOADED)}>
        <SVG.ExclamationMark />
      </IconButton>
    </FileUploadErrorWrapper>
  );
};
